import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { FiltersFormPerson } from 'shell/view-models/search-anpr';
import { DefaultFilterTable } from 'shell/constants/person-search';

const ActionsList = ({ cell, filterPersonForm }: ActionProps): React.ReactElement => {
  const navigate = useNavigate();
  const personFilterTable = useFilterTable<FiltersFormPerson>();
  const onVisibilityPress = useEventCallback(() => {
    return new Promise((resolve) => {
      personFilterTable.setValues(DefaultFilterTable);
      navigate({
        pathname: '/iscrizioni/aire-nascita-aggregazione/trascrizione',
        search: `?${createSearchParams({
          ricercaNazionale:
            filterPersonForm?.commonSearch?.isNationalResearch?.toString() ||
            filterPersonForm?.subjectData?.isNationalResearch?.toString() ||
            'false',
          codiceFiscale: cell?.fiscalCode || '',
        })}`,
      });
      resolve(cell);
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onVisibilityPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <VisibilityIcon />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list family page component';

export default ActionsList;
